export const SITE_LOGO = '/images/logo_btbp.png';
